import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { LayoutModule } from '@angular/cdk/layout';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ShellComponent } from './components/shell/shell.component';
import { UsermenuComponent } from './components/usermenu/usermenu.component';
import { UserSettingsComponent } from './components/user-settings/user-settings.component';
import { ConfigurationComponent } from './components/configuration/configuration.component';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { DividerModule } from 'primeng/divider';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ButtonModule } from 'primeng/button';
import { TenantSelectionComponent } from './components/tenant-selection/tenant-selection.component';
import { FormsModule } from '@angular/forms';
import { PopoverModule } from 'primeng/popover';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { ChipModule } from 'primeng/chip';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { DialogService } from 'primeng/dynamicdialog';
import { DrawerModule } from 'primeng/drawer';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { CheckboxModule } from 'primeng/checkbox';
import { PasswordModule } from 'primeng/password';
import { MessageModule } from 'primeng/message';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { SelectModule } from 'primeng/select';
import { DepartmentApiService } from 'app/core/api/services/department-api.service';

const components = [
  ShellComponent,
  UsermenuComponent,
  UserSettingsComponent,
  ConfigurationComponent,
  TenantSelectionComponent,
];

const modules = [
  CommonModule,
  LayoutModule,
  ReactiveFormsModule,
  RouterModule,
  ClipboardModule,
  MenuModule,
  MenubarModule,
  DividerModule,
  RadioButtonModule,
  ButtonModule,
  FormsModule,
  PopoverModule,
  AvatarModule,
  AvatarGroupModule,
  ChipModule,
  ProgressSpinnerModule,
  TableModule,
  CardModule,
  IconFieldModule,
  InputIconModule,
  InputTextModule,
  ToggleSwitchModule,
  DrawerModule,
  CheckboxModule,
  PasswordModule,
  MessageModule,
  InputGroupModule,
  InputGroupAddonModule,
  SelectModule,
];

@NgModule({
  imports: [...modules, ...components],
  exports: [...components, ...modules],
  providers: [DialogService, DepartmentApiService],
})
export class SharedModule {}
